export default __webpack_public_path__ + "static/deck-5ed2e0a072bcd23bf50912002ba13b3f.jpg";